<template>
  <div>
      <el-form :model="from" :rules="rules" ref="ruleForm" style="padding: 0 10%;" label-width="30%">
		<el-form-item label="组织架构" prop="organize_ids" style="margin-left:-80px">
			<el-cascader v-model="ruleForm.organize_ids" clearable
			    style="margin-left:1px;width:100%" collapse-tags :props="props"></el-cascader>
		</el-form-item>
		<el-form-item label="岗位" prop="post_id" style="margin-left:-80px">
			<el-select v-model="ruleForm.post_id" style="margin-left:1px;width:100%" placeholder="请选择岗位"
				clearable>
				<el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="计算方式" prop="calculation_method" style="margin-left:-80px">
			<!-- <el-select v-model="ruleForm.calculation_method" placeholder="请选择计算方式" clearable style="margin-left:1px;width:100%">
				<el-option v-for="age in countList" :key="age.id" :label="age.name"
					:value="age.id">
				</el-option>
			</el-select> -->
			<el-radio-group v-model="ruleForm.calculation_method">
			    <el-radio v-for="calculation_method in countList" :key="calculation_method.id" :label="calculation_method.type"
					:value="calculation_method.id">{{calculation_method.name}}</el-radio>
			  </el-radio-group>
			  
		</el-form-item>
		<el-form-item style="text-align: center;" label-width="0px">
			<el-button type="primary" @click="Add"
				style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
		</el-form-item>
	</el-form>
  </div>
</template>

<script>
export default {
    data(){
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
		        return organizeList.data;
		    };
        return{
			//组织架构数据
			organizeList: [],
			//职位数据
			postList: [],
			countList:[],
			type:'',
            ruleForm:{
				id:'',
				organize_ids: [],
				post_id:'',	
				calculation_method:'',
			},
			//级联下拉配置
			props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: true,
			},
        }
    },
    methods:{
        async Add() {
			if(this.ruleForm.organize_ids == ''){
				this.$message.error('请选择组织架构！');
			}else if(this.ruleForm.post_id == ''){
				this.$message.error('请选择岗位！');
			}else if(this.ruleForm.calculation_method == ''){
				this.$message.error('请选择计算方式！');
			}else{
				var temporary = [];
				this.ruleForm.organize_ids.forEach(item => {
				    temporary.push(item[item.length - 1]);
				})
				this.ruleForm.organize_ids = temporary
				var url = 'OrganizeSalary/insertOrganizeSalary';
				var record = {
					project_ids: this.ruleForm.organize_ids,
					post_id:this.ruleForm.post_id,
					calculation_method:this.ruleForm.calculation_method,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Return();
						this.trash();
					} else {
						this.$message.warning(data);
					}
				}
			}	
		},
			
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.organize_ids = [];
				this.ruleForm.organize_ids = '';
				this.ruleForm.post_id = '';
				this.ruleForm.insurance_price = '';
				this.ruleForm.calculation_method ='';
			},
    },
    async created() {
		this.ruleForm = this.$parent.$parent.ruleForm;
		// 职位数据
		var postList = await this.$globals.AxiosPost('post/selectFind', {});
		this.postList = postList.data;
		
		//计算方式查询
		var countList = await this.$globals.AxiosPost('OrganizeSalary/getMode', {});
		this.countList = countList.data;
		},
		

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// jsfs_add.vue?6cd3a89d